module.exports = __webpack_public_path__ + "img/13.29b8ed94.jpg";